import React from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';

function Footer({ locale, info, navbar }) {
    let titles = locale === 'ru' ? ['Разделы', 'Контакты', 'Адрес'] : ['Sections', 'Contacts', 'Address'];
    let navbarSort = navbar ? [...navbar].sort((a, b) => a.order - b.order) : []
    let email = 'e-mail:';
    let email_v = info?.email
    let number = locale === 'ru' ? 'Телефон:' : 'Phone number:';
    let number_v = info?.num;
    let address = locale === 'ru' ? 'Адрес:' : 'Address: ';
    let address_v = info?.address;
    let a = locale === 'ru' ? 'политика обработки персональных данных' : 'Personal data processing policy';
    let href = info?.personal_data_processing_policy;

    return (
        <div className='footer'>
            <Box sx={{ bgcolor: '#2D5B96', p: 6, mt: 5 }}>
                <Container>
                    <Grid container color='white'>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <Typography gutterBottom variant="h5" component="div">
                                {titles[0]}
                            </Typography>
                            {navbarSort !== null && navbarSort.map((item,index) =>
                                <Typography key={index} gutterBottom variant="body2" component="div" >
                                    <a href={item?.url}>{item?.name}</a>
                                </Typography>
                            )}
                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <Typography gutterBottom variant="h5" component="div">
                                {titles[1]}
                            </Typography>
                            <Typography gutterBottom variant="body2" component="div">
                                {email}{email_v}
                            </Typography>
                            <Typography gutterBottom variant="body2" component="div">
                                {number}{number_v}
                            </Typography >
                            <Typography sx={{ color: '#fff', textDecoration: 'underline' }}>
                                <a href={href}>{a}</a>
                            </Typography>

                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <Typography gutterBottom variant="h5" component="div">
                                {titles[2]}
                            </Typography>
                            <Typography gutterBottom variant="body2" component="div">
                                {address}{address_v}
                            </Typography>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
        </div>
    );
}

export default Footer;
